import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(undefined); // undefined = loading

  const load = useCallback(async () => {
    if (!localStorage.getItem("aura_token")) {
      setUser(null);
      return;
    }
    try {
      const r = await api.get("/auth/me");
      setUser(r.data);
    } catch {
      localStorage.removeItem("aura_token");
      setUser(null);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  const login = async (email, password) => {
    const r = await api.post("/auth/login", { email, password });
    localStorage.setItem("aura_token", r.data.token);
    setUser(r.data.user);
    return r.data.user;
  };

  const register = async (name, email, password, phone = "") => {
    const r = await api.post("/auth/register", { name, email, password, phone });
    localStorage.setItem("aura_token", r.data.token);
    setUser(r.data.user);
    return r.data.user;
  };

  const otpLogin = async (identifier, otp, name = "") => {
    const r = await api.post("/auth/otp/verify", { identifier, otp, name });
    localStorage.setItem("aura_token", r.data.token);
    setUser(r.data.user);
    return r.data.user;
  };

  const magicLogin = async (token) => {
    const r = await api.post("/auth/magic/verify", { token });
    localStorage.setItem("aura_token", r.data.token);
    setUser(r.data.user);
    return r.data.user;
  };

  const logout = () => {
    localStorage.removeItem("aura_token");
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, login, register, otpLogin, magicLogin, logout, reload: load }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
